import React from 'react'
import { Button } from '@fs/zion-ui'
import { NoticeLoading } from '@fs/zion-icon'
import { useTranslation } from 'react-i18next'
import RequestStatus from './RequestStatus'

export default function SubmitButton(props) {
  const { t } = useTranslation()
  const { children = t('common-ui:save.action', 'Save'), disabled, isSubmitting, as, ...rest } = props
  const TagName = as || Button
  return (
    <>
      <RequestStatus loading={isSubmitting} invisible />
      <TagName
        emphasis="high"
        id="submit-button"
        disabled={disabled || isSubmitting}
        Icon={isSubmitting ? NoticeLoading : undefined}
        iconAtEnd
        {...rest}
      >
        {children}
      </TagName>
    </>
  )
}
